import { Route } from "react-router";
import {
  ChatPage,
  HomePage,
  TransactionStatsPage,
  BranchesPage,
  AddBranchPage,
  EditBranchPage,
  BranchPage,
  ProductsPage,
  OrdersPage,
  WebsiteOrdersPage,
  HistoryPage,
  TemporaryCreditsPage,
  ClientManagementPage,
  SalesAgentsPage,
  SalesAgentCommissionsPage,
  ReferralClientsPage,
  ReferralCashbackPage,
  LivePricingPage,
  PhysicalProductsPage,
  MarketSettingsPage,
  MarketUpdatesPage,
  CountriesPage,
  BankPage,
  OffersPage,
  PushNotificationsPage,
  AppVersionControl,
  AdminSettingsPage,
  AuditLogsPage,
  AddAdminPage,
  EditAdminPage,
  AddPermissionsPage,
  PasswordPage,
  PositionsPage,
  LiveTransactionsPage,
  PendingWithDrawalPage,
  UserChangeRequestsPage,
  MoneyTransactionsReportPage,
  LoansReportPage,
  EsouqOrdersReportPage,
  StatementsReportPage,
  DemoUsersStatementsReportPage,
  UsersStatementReportPage,
  UsersCashbackReportPage,
  InvestmentInsightsReportPage,
  AccountsMappingPage,
  BankAccountMappingPage,
  FixingMappingPage,
  PhysicalMappingPage,
  AccessDeniedPage,
  ProtectedRoute,
  AnimatedRoute,
  UsersMismatchedBalanceReportPage,
  ComplianceTransactionsPage,
  ComplianceUsersPage,
  ComplianceKycPage,
} from "../import";

const AdminRoutes = () => (
  <>
    <Route
      path="home"
      element={
        <AnimatedRoute>
          <HomePage />
        </AnimatedRoute>
      }
    />
    <Route
      path="transaction-stats"
      element={
        <AnimatedRoute>
          <TransactionStatsPage />
        </AnimatedRoute>
      }
    />

    <Route path="e-souq-manager">
      <Route path="branches">
        <Route
          index
          element={
            <ProtectedRoute
              requiredPermission={{ section: "branches", action: "canView" }}
            >
              <AnimatedRoute>
                <BranchesPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="create-branch"
          element={
            <ProtectedRoute
              requiredPermission={{ section: "branches", action: "canCreate" }}
            >
              <AnimatedRoute>
                <AddBranchPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <ProtectedRoute
              requiredPermission={{
                section: "branches",
                action: "canEditDelete",
              }}
            >
              <AnimatedRoute>
                <EditBranchPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path=":id"
          element={
            <ProtectedRoute
              requiredPermission={{ section: "branches", action: "canView" }}
            >
              <AnimatedRoute>
                <BranchPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="products">
        <Route
          index
          element={
            <ProtectedRoute
              requiredPermission={{
                section: "esouqProducts",
                action: "canView",
              }}
            >
              <AnimatedRoute>
                <ProductsPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="orders">
        <Route
          index
          element={
            <ProtectedRoute
              requiredPermission={{ section: "order", action: "canView" }}
            >
              <AnimatedRoute>
                <OrdersPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="website-orders">
        <Route
          index
          element={
            <ProtectedRoute
              requiredPermission={{ section: "order", action: "canView" }}
            >
              <AnimatedRoute>
                <WebsiteOrdersPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
      </Route>
    </Route>

    <Route
      path="history"
      element={
        <ProtectedRoute
          requiredPermission={{ section: "history", action: "canView" }}
        >
          <AnimatedRoute>
            <HistoryPage />
          </AnimatedRoute>
        </ProtectedRoute>
      }
    />
    <Route
      path="temporary-credits"
      element={
        <ProtectedRoute
          requiredPermission={{ section: "history", action: "canView" }}
        >
          <AnimatedRoute>
            <TemporaryCreditsPage />
          </AnimatedRoute>
        </ProtectedRoute>
      }
    />

    <Route path="clients">
      <Route
        index
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "clientManagement",
              action: "canView",
            }}
          >
            <AnimatedRoute>
              <ClientManagementPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="referral">
      <Route
        path="clients"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "referralClients",
              action: "canView",
            }}
          >
            <AnimatedRoute>
              <ReferralClientsPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="cashback"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "referralCashback",
              action: "canView",
            }}
          >
            <AnimatedRoute>
              <ReferralCashbackPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="sales-agents">
      <Route
        index
        element={
          <ProtectedRoute
            requiredPermission={{ section: "salesAgents", action: "canView" }}
          >
            <AnimatedRoute>
              <SalesAgentsPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="commissions"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "salesAgentCommissions",
              action: "canView",
            }}
          >
            <AnimatedRoute>
              <SalesAgentCommissionsPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="controls">
      <Route
        path="live-pricing"
        element={
          <ProtectedRoute
            requiredPermission={{ section: "livePricing", action: "canView" }}
          >
            <AnimatedRoute>
              <LivePricingPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route path="physical-products">
        <Route
          index
          element={
            <ProtectedRoute
              requiredPermission={{
                section: "esouqProducts",
                action: "canView",
              }}
            >
              <AnimatedRoute>
                <PhysicalProductsPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="market-management"
        element={
          <ProtectedRoute
            requiredPermission={{ section: "marketHours", action: "canView" }}
          >
            <AnimatedRoute>
              <MarketSettingsPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="news"
        element={
          <ProtectedRoute
            requiredPermission={{ section: "news", action: "canView" }}
          >
            <AnimatedRoute>
              <NewsManagementPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="market-updates"
        element={
          <ProtectedRoute
            requiredPermission={{ section: "marketUpdates", action: "canView" }}
          >
            <AnimatedRoute>
              <MarketUpdatesPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="countries"
        element={
          <ProtectedRoute
            requiredPermission={{ section: "countries", action: "canView" }}
          >
            <AnimatedRoute>
              <CountriesPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route path="banks">
        <Route
          index
          element={
            <ProtectedRoute
              requiredPermission={{ section: "banks", action: "canView" }}
            >
              <AnimatedRoute>
                <BankPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
      </Route>
    </Route>

    <Route path="settings">
      <Route
        path="offers"
        element={
          <ProtectedRoute
            requiredPermission={{ section: "offers", action: "canView" }}
          >
            <AnimatedRoute>
              <OffersPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="push-notifications"
        element={
          <AnimatedRoute>
            <PushNotificationsPage />
          </AnimatedRoute>
        }
      />
      <Route
        path="app-version-controls"
        element={
          <ProtectedRoute
            requiredPermission={{ section: "appConfigs", action: "canView" }}
          >
            <AnimatedRoute>
              <AppVersionControl />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route path="admin-settings">
        <Route
          index
          element={
            <ProtectedRoute
              requiredPermission={{
                section: "adminManagement",
                action: "canView",
              }}
            >
              <AnimatedRoute>
                <AdminSettingsPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="create-admin"
          element={
            <ProtectedRoute
              requiredPermission={{
                section: "adminManagement",
                action: "canCreate",
              }}
            >
              <AnimatedRoute>
                <AddAdminPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <ProtectedRoute
              requiredPermission={{
                section: "adminManagement",
                action: "canEditDelete",
              }}
            >
              <AnimatedRoute>
                <EditAdminPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path=":id/add-permissions"
          element={
            <ProtectedRoute
              requiredPermission={{
                section: "adminManagement",
                action: "canEditDelete",
              }}
            >
              <AnimatedRoute>
                <AddPermissionsPage />
              </AnimatedRoute>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="audit-logs"
        element={
          <ProtectedRoute
            requiredPermission={{ section: "adminManagement", action: "canView" }}
          >
            <AnimatedRoute>
              <AuditLogsPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route path="change-password" element={<PasswordPage />} />
    </Route>

    <Route path="positions">
      {/* Stats, Open, Buy At Price, Take Profit and Closed are tabs (?tab=) of one page; it checks each tab's permission itself */}
      <Route
        index
        element={
          <AnimatedRoute>
            <PositionsPage />
          </AnimatedRoute>
        }
      />
    </Route>

    <Route
      path="live-transactions"
      element={
        <ProtectedRoute
          requiredPermission={{ section: "liveTransaction", action: "canView" }}
        >
          <AnimatedRoute>
            <LiveTransactionsPage />
          </AnimatedRoute>
        </ProtectedRoute>
      }
    />

    <Route path="requests">
      <Route
        path="pending-withdrawal-requests"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "withdrawalsRequests",
              action: "canView",
            }}
          >
            <AnimatedRoute>
              <PendingWithDrawalPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="user-change-requests"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "clientInfoChangeRequests",
              action: "canView",
            }}
          >
            <AnimatedRoute>
              <UserChangeRequestsPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="reports">
      <Route
        path="money-transactions"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "reports",
              action: "canViewMoneyTransactionsReport",
            }}
          >
            <AnimatedRoute>
              <MoneyTransactionsReportPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="loans"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "reports",
              action: "canViewLoansReport",
            }}
          >
            <LoansReportPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="esouq-orders"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "reports",
              action: "canViewEsouqOrdersReport",
            }}
          >
            <AnimatedRoute>
              <EsouqOrdersReportPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="statements"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "reports",
              action: "canViewStatementsReport",
            }}
          >
            <AnimatedRoute>
              <StatementsReportPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="demo-users-statements"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "reports",
              action: "canViewStatementsReport",
            }}
          >
            <AnimatedRoute>
              <DemoUsersStatementsReportPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="users-mismatched-balance"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "reports",
              action: "canViewStatementsReport",
            }}
          >
            <AnimatedRoute>
              <UsersMismatchedBalanceReportPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="users-statement"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "reports",
              action: "canViewStatementsReport",
            }}
          >
            <AnimatedRoute>
              <UsersStatementReportPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="users-cashback"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "reports",
              action: "canViewStatementsReport",
            }}
          >
            <AnimatedRoute>
              <UsersCashbackReportPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="investment-insights"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "reports",
              action: "canViewStatementsReport",
            }}
          >
            <AnimatedRoute>
              <InvestmentInsightsReportPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="compliance">
      <Route
        path="transactions"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "compliance",
              action: "canViewTransactions",
            }}
          >
            <AnimatedRoute>
              <ComplianceTransactionsPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="users"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "compliance",
              action: "canViewUsers",
            }}
          >
            <AnimatedRoute>
              <ComplianceUsersPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="kyc"
        element={
          <ProtectedRoute
            requiredPermission={{
              section: "compliance",
              action: "canViewKyc",
            }}
          >
            <AnimatedRoute>
              <ComplianceKycPage />
            </AnimatedRoute>
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="neo-financials">
      <Route
        path="accounts-mapping"
        element={
          <AnimatedRoute>
            <AccountsMappingPage />
          </AnimatedRoute>
        }
      />
      <Route
        path="credit-debit-accounts-mapping"
        element={
          <AnimatedRoute>
            <BankAccountMappingPage />
          </AnimatedRoute>
        }
      />
      <Route
        path="fixing-mapping"
        element={
          <AnimatedRoute>
            <FixingMappingPage />
          </AnimatedRoute>
        }
      />
      <Route
        path="physical-mapping"
        element={
          <AnimatedRoute>
            <PhysicalMappingPage />
          </AnimatedRoute>
        }
      />
    </Route>

    <Route
      path="chat"
      element={
        <AnimatedRoute>
          <ChatPage />
        </AnimatedRoute>
      }
    />

    <Route path="access-denied" element={<AccessDeniedPage />} />
  </>
);

export default AdminRoutes;
